import _ from 'lodash';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';
import { purpurColorVariables } from '@telialt/common-theme/src/purpurTokens';

export const getSupportedColor = (color: string) => {
    if (!color) {
        return getPurpurColor('textDefault');
    }
    const camelCaseToken = _.camelCase(color);
    const fromToken = purpurColorVariables[camelCaseToken];

    return fromToken || getPurpurColor('textDefault');
};
